// extracted by mini-css-extract-plugin
module.exports = {"imgContainer":"product-image_imgContainer__0TM0f","img":"product-image_img__4hVbU","unavailable":"product-image_unavailable__VzdCe"};